import React, { useState, useEffect } from 'react';
import { CalendarOutlined, FireOutlined, TagsOutlined } from '@ant-design/icons';
import { Card, Tag, Button, Badge } from 'antd';
import { Link } from 'react-router-dom';
import './index.css';

const Home = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('all');

  // 模拟从API获取数据
  useEffect(() => {
    const fetchArticles = () => {
      // 这里可以使用你的mock API
      const stored = JSON.parse(localStorage.getItem('articles') || '[]');
      
      // 如果没有数据，使用示例数据
      if (stored.length === 0) {
        const sampleArticles = [
          {
            id: 1,
            title: '生活是用来享受的',
            abstract: '慢下来，感受生活中的每一刻美好与温暖',
            content: '',
            tags: ['#生活'],
            date: '2025-12-23',
            likes: 42,
            views: 156
          },
          {
            id: 2,
            title: '人间至味是寻常',
            abstract: '最朴素的食物，往往藏着最深刻的味道',
            content: '',
            tags: ['#美食'],
            date: '2025-12-23',
            likes: 38,
            views: 189
          },
          {
            id: 3,
            title: '猫与时光，皆是温柔',
            abstract: '猫咪蜷缩在窗台，阳光正好，岁月静好',
            content: '',
            tags: ['#可爱', '#我的毛孩子'],
            date: '2025-12-23',
            likes: 56,
            views: 234
          },
          {
            id: 4,
            title: '一碗酸奶，装下夏日的甜',
            abstract: '自制酸奶的简单快乐',
            content: '',
            tags: ['#酸奶瓶'],
            date: '2025-12-23',
            likes: 29,
            views: 127
          },
          {
            id: 5,
            title: '动物城：以梦想打破偏见，以温柔拥抱世界',
            abstract: '每一个梦想都值得被尊重',
            content: '',
            tags: ['#疯狂动物城'],
            date: '2025-12-23',
            likes: 67,
            views: 312
          },
          {
            id: 6,
            title: '炭火烤鱼：烟火里的鲜香秘密',
            abstract: '炭火与鱼的完美邂逅',
            content: '',
            tags: ['#美食'],
            date: '2025-12-23',
            likes: 45,
            views: 198
          }
        ];
        setArticles(sampleArticles);
        localStorage.setItem('articles', JSON.stringify(sampleArticles));
      } else {
        setArticles(stored);
      }
      
      setLoading(false);
    };

    fetchArticles();
  }, []);

  // 获取所有标签
  const allTags = Array.from(new Set(articles.flatMap(article => article.tags)));

  // 过滤文章
  const filteredArticles = activeFilter === 'all' 
    ? articles 
    : articles.filter(article => article.tags.includes(activeFilter));

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="home-container">
      {/* 热门标签筛选区 */}
      <section className="tags-section">
        <div className="section-header">
          <h2><TagsOutlined /> 热门标签</h2>
        </div>
        <div className="tags-container">
          <Badge count={articles.length}>
            <Tag 
              className={`tag-item ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
            >
              全部
            </Tag>
          </Badge>
          {allTags.map(tag => (
            <Tag 
              key={tag}
              className={`tag-item ${activeFilter === tag ? 'active' : ''}`}
              onClick={() => setActiveFilter(tag)}
            >
              {tag}
            </Tag>
          ))}
        </div>
      </section>

      {/* 最新文章区域 */}
      <section className="articles-section">
        <div className="section-header">
          <h2><CalendarOutlined /> 最新文章</h2>
          <Link to="/archive">
            <Button type="link">查看全部 →</Button>
          </Link>
        </div>
        
        <div className="articles-grid">
          {filteredArticles.slice(0, 6).map(article => (
            <Card 
              key={article.id}
              className="article-card"
              hoverable
              onClick={() => window.location.href = `/post?id=${article.id}`}
            >
              <div className="article-header">
                <Badge.Ribbon 
                  text="NEW" 
                  color="#ff6b6b"
                  style={{ display: article.isNew ? 'block' : 'none' }}
                >
                  <h3 className="article-title">{article.title}</h3>
                </Badge.Ribbon>
                <div className="article-meta">
                  <span className="article-date">
                    <CalendarOutlined /> {article.date}
                  </span>
                  <div className="article-stats">
                    <span className="stat-item">
                      <FireOutlined /> {article.likes}
                    </span>
                    <span className="stat-item">
                      👁️ {article.views}
                    </span>
                  </div>
                </div>
              </div>
              
              <p className="article-abstract">{article.abstract}</p>
              
              <div className="article-footer">
                <div className="article-tags">
                  {article.tags.map(tag => (
                    <Tag key={tag} className="article-tag">
                      {tag}
                    </Tag>
                  ))}
                </div>
                <Button type="link" className="read-more">
                  阅读全文 →
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </section>

      {/* 月度精选区域 */}
      <section className="featured-section">
        <div className="section-header">
          <h2>🎯 本月精选</h2>
        </div>
        <Card className="featured-card">
          <div className="featured-content">
            <div className="featured-image">
              <img 
                src="/烤鱼.jpg" 
                alt="炭火烤鱼" 
              />
            </div>
            <div className="featured-text">
              <h3>📌 炭火烤鱼：烟火里的鲜香秘密</h3>
              <p>探索炭火烤鱼的制作奥秘，从选鱼到调味，每一步都藏着对美食的热爱...</p>
              <div className="featured-tags">
                <Tag color="#ff6b6b">美食</Tag>
                <Tag color="#4ecdc4">生活</Tag>
                <Tag color="#45b7d1">教程</Tag>
              </div>
              <div className="featured-stats">
                <span>🔥 热门文章</span>
                <span>👑 编辑推荐</span>
                <span>⭐ 月度之星</span>
              </div>
            </div>
          </div>
        </Card>
      </section>
    </div>
  );
};

export default Home;